import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { store } from "@/store";
import { MODULES, vuexName } from "@/store/utils";

export default (to: RouteLocationNormalized, _from: RouteLocationNormalized, _next: NavigationGuardNext) => {
  if (to.meta) store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_LAYOUT, false), { layout: to.meta.layout });
};
